
import { accommodationMapping } from '../mappings/AccommodationMapping';
import { experienceMapping } from '../mappings/ExperienceMapping';
import { locationMapping } from '../mappings/LocationMapping';

export const getUsedTerms = (
  detectedAccommodationType: string | null,
  detectedExperienceType: string | null,
  detectedLocation: any
): string[] => {
  const usedTerms: string[] = [];
  
  if (detectedAccommodationType) {
    usedTerms.push(...accommodationMapping[detectedAccommodationType as keyof typeof accommodationMapping]);
  }
  
  if (detectedExperienceType) {
    usedTerms.push(...experienceMapping[detectedExperienceType as keyof typeof experienceMapping]);
  }
  
  if (detectedLocation) {
    if (detectedLocation.type === 'city') {
      usedTerms.push(...Object.keys(locationMapping.cities).filter(key => 
        locationMapping.cities[key] === detectedLocation.info
      ));
    } else if (detectedLocation.type === 'region') {
      usedTerms.push(...Object.keys(locationMapping.regions).filter(key => 
        locationMapping.regions[key] === detectedLocation.info
      ));
    } else if (detectedLocation.type === 'country') {
      usedTerms.push(...Object.keys(locationMapping.countries).filter(key => 
        locationMapping.countries[key] === detectedLocation.info.country
      ));
    }
  }
  
  return usedTerms;
};

export const applyBroadSearch = (dbQuery: any, searchTerms: string[]) => {
  const searchConditions: string[] = [];
  
  searchTerms.forEach(term => {
    searchConditions.push(
      `name.ilike.%${term}%`,
      `description.ilike.%${term}%`,
      `city.ilike.%${term}%`,
      `country.ilike.%${term}%`,
      `region.ilike.%${term}%`,
      `facilities.ilike.%${term}%`,
      `categoryPath.ilike.%${term}%`,
      `specialCategories.ilike.%${term}%`,
      `typeAccommodatie.ilike.%${term}%`,
      `typeVakantie.ilike.%${term}%`
    );
  });

  if (searchConditions.length > 0) {
    return dbQuery.or(searchConditions.join(','));
  }
  
  return dbQuery;
};

export const validateVacationData = (data: any[]) => {
  return (data || []).map((vacation: any) => ({
    ...vacation,
    name: vacation.name || "Onbekende vakantie",
    imageURL: vacation.imageURL || "/placeholder.svg"
  }));
};
